import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FlightsState } from "./types";
import { TClassOfService, TPassengerType } from "@/shared/api/aviabooking/types";
import { fetchFlights } from "./flights-thunk";
import { ErrorType } from "@/shared/types";

const initialState: FlightsState = {
    flights: [],
    isFlightsLoading: false,
    isFlightsFirstLoad: true,
    flightsError: null,
}

const flightsSlice = createSlice({
    name: 'flights',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchFlights.pending, (state) => {
            state.isFlightsLoading = true
            state.isFlightsFirstLoad = true
            state.flightsError = null
            state.flights = []
        })
        .addCase(fetchFlights.fulfilled, (state, action) => {
            state.flights = action.payload.flights || []
            state.isFlightsLoading = false
            state.isFlightsFirstLoad = false
            state.flightsError = null
        })
        .addCase(fetchFlights.rejected, (state, action) => {
            state.isFlightsLoading = false
            state.flightsError = action.payload as ErrorType
        })
    },
})

export default flightsSlice.reducer